var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Event } from 'lincd-schema/shapes/Event';
import { irlcg } from '../ontologies/irlcg.js';
import { Literal } from 'lincd/models';
import { literalProperty } from 'lincd/shapes/SHACL';
import { linkedShape } from '../package.js';
import { Server } from 'lincd-server-utils/utils/Server';
let Meeting = class Meeting extends Event {
    get meetingType() {
        return this.getValue(irlcg.meetingType);
    }
    set meetingType(val) {
        this.overwrite(irlcg.meetingType, new Literal(val));
    }
    static getRemainingMeeting(additional) {
        return Server.call(this, 'getRemainingMeeting', additional);
    }
};
Meeting.targetClass = irlcg.Meeting;
__decorate([
    literalProperty({
        path: irlcg.meetingType,
        maxCount: 1,
        // in: [
        //   new Literal('inPerson'),
        //   new Literal('online'),
        //   new Literal('hybrid'),
        // ],
        description: 'Meeting format (inPerson, online, hybrid)',
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Meeting.prototype, "meetingType", null);
Meeting = __decorate([
    linkedShape({
        description: 'A team meeting event. Represents scheduled gatherings with meeting type (in person or online). (gathering, session, assembly)',
    })
], Meeting);
export { Meeting };
//# sourceMappingURL=Meeting.js.map